<template>
    <SOSlotModal  
        modal-title="Promo"
        :modal-id="id"
        :no-padding="true"
        @close="close()"
    >
        <template v-slot:modal-body>
            <div v-if="isLoading" class="d-flex justify-content-center p-5" style="gap: 3px;">
                <span class="spinner-border spinner-border-sm f-c-midgrey " role="status" aria-hidden="true"></span>
                <span class="f-14 f-c-midgrey">
                    Memuat data...
                </span>
            </div>
            <div v-else class="p-x-20 pt-3">
                <div class="">
                    Promo Tersedia
                </div>
                <div id="list_container">
                    <div
                        v-for="(listPromo, index) in listPromo"
                        :key="index"
                        :class="`border rounded mb-3 ${picked.kode == listPromo.kode ? 'selected' : ''}`"
                    >
                        <label class="w-100 p-y-10 p-x-20" :for="index">
                            <div class="d-flex justify-content-between align-items-center position-relative">
                                <span class="f-16 f-semi text-uppercase">
                                    {{ listPromo.kode }}
                                </span>
                                <input class="" type="radio" :id="index" :value="listPromo" v-model="picked" />
                                <span class="checkmark"/>
                            </div>
                            <span>Diskon {{listPromo.diskon }}% Sampai Tanggal {{ $moment (listPromo.expired).format("DD MMM YYYY") }}</span>
                        </label>
                    </div>
                </div>
                <div class="separator-line" />
                <div id="kode_promo" class="my-3">
                    <SOInputSearch
                        id="cari-konsumen"
                        placeholder="Ketuk untuk mencari...."
                        v-model="promo.kode"
                        autocomplete="off"
                        :do-searching="validatingCoupon"
                        hide-icon
                        clearable
                        :delay-time="1000"
                        @clear="() => {
                            picked = {};
                            promo = {
                                kode: null,
                                isValid: null
                            };
                            coupon = null;
                        }"
                    />
                    <template v-if="promo.kode">
                        <div class="d-flex mt-2" v-if="validating" style="gap: 5px;">
                            <span class="spinner-border spinner-border-sm f-c-midgrey " role="status" aria-hidden="true"></span>
                            <span class="f-14 f-c-midgrey">
                                Tunggu sebentar...
                            </span>
                        </div>
                        <template v-else>
                            <div class="d-flex mt-1" v-if="promo.isValid">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM10.4714 7.13809C10.7318 6.87774 10.7318 6.45563 10.4714 6.19528C10.2111 5.93493 9.78894 5.93493 9.52859 6.19528L7.33333 8.39055L6.47141 7.52862C6.21106 7.26827 5.78895 7.26827 5.5286 7.52862C5.26825 7.78896 5.26825 8.21107 5.5286 8.47143L6.86193 9.80476C6.98695 9.92978 7.15652 10 7.33333 10C7.51014 10 7.67971 9.92978 7.80474 9.80476L10.4714 7.13809Z" fill="#24A148"/>
                                </svg>
                                <span class="f-12 f-c-green pl-1">Voucher berhasil digunakan!</span>
                            </div>
                            <div v-else class="d-flex mt-1">
                                <i class="fas fa-exclamation-triangle f-c-red"></i>
                                <span class="f-12 f-c-red pl-1">Kode voucher tidak dapat digunakan.</span>
                            </div>
                        </template>
                    </template>
                </div>
                <div id="info" class="d-flex align-items-center p-y-8 p-l-20 rounded my-3">
                    <i class="fas fa-exclamation-triangle f-c-red"></i>
                    <div class="f-12 f-c-midgrey">
                        Jika anda menggunakan kode promo baru, maka promo sebelum nya akan hangus
                    </div>
                </div>
            </div>
        </template>
        
        <template v-if="!isLoading" v-slot:modal-footer>
            <div class="p-x-20">
                <SOButton
                    :text="'Gunakan Kode Promo'"
                    :primary="true"
                    :full="true"
                    :loading="claiming"
                    :disable="coupon == null || (claiming || validating)"
                    @action="usePromo()"
                />
            </div>
        </template>
    </SOSlotModal>
</template>

<script>
import { mapActions } from "vuex"
import { moduleName } from "../../store/state";
import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../../apiEndPoint.js";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOInputSearch from "@/so-components/global/input/SOInputSearch.vue";
export default {
    name: "ModalPromo",
    components: {
        SOSlotModal,
        SOButton,
        SOInputRegular,
        SOInputSearch,
    },
    props: {
        fitur: {
            type: String,
            default: "masal_transaksi"
        }
    },
    data () {
        return {
            id:"modal_promo",
            picked: {},
            promo: {
                kode: null,
                isValid: null,
            },
            listPromo: [],
            isLoading: false,
            validating: false,
            claiming: false,
            coupon: null,
        }
    },
    computed: {
        isDisable() {
            return this.coupon != null && (this.claiming || this.validating)
        }
    },
    methods: {
        ...mapActions({
            getListPromo: `${moduleName}/getListPromo`,
            validatingPromo: `${moduleName}/validatingPromo`,
            getCoinEstimation: `${moduleName}/getCoinEstimation`,
        }),
        async validatingCoupon() {
            this.validating = true
            const payload = {
                kode: this.promo.kode,
                fitur: this.fitur
            }
            try {
                this.coupon = null
                const res = await conn.post(api.coupon.coupon_validaton, payload, conn.contentType.json)
                if (res.data.data.validation) {
                    this.coupon = res.data.data.coupon
                }
                else {
                    this.$toast.error(res.data.data.msg)    
                }
                this.promo.isValid = res.data.data.validation
                this.validating = false
            } catch (error) {
                this.$toast.error('Gagal validasi promo: ' + error)
                this.validating = false
            }
        },
        async getPromo() {
            try {
                this.isLoading = true;
                this.listPromo = [];
                const res = await conn.get(api.coupon.index + this.fitur)
                this.listPromo = res.data.data.couponList
                this.isLoading = false;
            } catch (error) {
                console.log(error);
                this.isLoading = false;
                return resulter.errorResult(error)
            }
        },
        open() {
            $("#" + this.id).modal("show");
            this.getPromo()
        },
        close() {
            $("#" + this.id).modal("hide");
            setTimeout(() => {
                this.$emit("close");
                this.kode = "";
                this.picked = {};
            }, 500);
        },
        usePromo() {
            switch (this.fitur) {
                case "masal_transaksi_cron":
                    this.claimPromo()
                    break;
            
                default:
                    this.confirm()
                    break;
            }
        },
        async claimPromo() {
            this.claiming = true
            try {
                const res = await conn.post(api.coupon.cron_coupon_claim, { kode: this.promo.kode }, conn.contentType.json)
                if (res.data.status) {
                    this.$toast.success('Promo berhasil diklaim')
                    await this.getCoinEstimation()
                    this.confirm()
                } else {
                    this.$toast.error('Promo gagal diklaim. ' + res.data.msg)
                }
                this.claiming = false
            } catch (error) {
                this.$toast.error('Gagal validasi promo: ' + error)
                this.claiming = false
            }
        },
        confirm() {
            this.close();
            this.$emit("selected", this.coupon);
        },
    },
    watch: {
        picked: {
            handler(newVal) {
                if (newVal.kode) {
                    this.promo.kode = JSON.parse(JSON.stringify(newVal.kode));
                    this.validatingCoupon()
                }
            },
            deep: true,
        },
    }
}
</script>

<style scoped>
#button >>> .btn-outline-danger{
    margin-bottom: 1rem
}
label {
    margin: 0 !important;
}
#list_container {
    max-height: 300px;
    overflow-y: auto;
}
.selected {
    border-color: rgba(32, 108, 255, 1) !important;
    background: rgba(237, 245, 255, 1);
}
.checkmark {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    border: 1px solid #C8D0DD;
}
.checkmark:after {
  content: "";
  display: none;
}
#list_container input:checked ~ .checkmark:after {
  display: block;
}
#list_container .checkmark:after {
 	top: 9px;
	left: 9px;
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: white;
}
#list_container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}
#list_container input:checked ~ .checkmark {
  background-color: #2196F3;
  border: 0;
}
#kode_promo >>> input {
    text-transform: uppercase;
}
#info {
    background: #FFF1F1;
    gap: 16px
}
</style>